<template>
  <v-dialog
    v-model="dialog"
    persistent
    :max-width="isOsStlye.maxWidth"
    @keydown.esc="closeDialog"
  >
    <v-card>
      <!-- layer_popWrap -->
      <div>
        <h3 class="popup-title" style="height: 60px; line-height: 60px;">회의 불러오기</h3>
      </div>
      <div class="dataTable" style="padding-bottom: 5px; min-height: 200px">
        <div class="popup_tel_wrap" style="overflow: hidden;">
          <div
            class="list"
            style="width: 33%; max-height: 450px; overflow-y: auto;"
          >
            <span class="list_title">저장된 회의 목록</span>
            <!-- <div style="float:right; width: 60px;" class="bookmark-delete-btn" :style="{ background: btnActive }" @click="openDeleteBtn()" >
              <div class="fl mgl35">
                <a class="btn_delete" style="color:white;">삭제</a>
              </div>
            </div> -->
            <table style="border-top: 2px solid #333; margin-top: 10px;">
              <tr v-for="(listItem, index) in calData" :key="index">
                <td
                  :class="{ activeTarget: listItem.bindActive }"
                  style="width: 150px; padding-left:0; cursor:pointer; text-align:center; font-size: 15px;"
                  @click="selectBookmark(listItem)"
                >
                  {{ listItem.bookmarkTitle }}
                </td>
                <td style="width: 20px;">
                  <!-- <td v-bind:style="{display:isActive}" style="width: 20px;"> -->
                  <div
                    class="btn_check_box"
                    style="padding-top: 0; text-align: center;"
                  >
                    <img
                      style="width: 13px; cursor: pointer"
                      src="../../../src/images/button/btnClose.png"
                      :label="listItem._id"
                      @click="deleteMeetingBookmark(listItem._id)"
                    />
                  </div>
                </td>
              </tr>
            </table>
          </div>
          <!-- /.list -->

          <div
            class="list_on"
            style="width: 67%; max-height: 450px; overflow-y: auto;"
          >
            <span class="list_title">선택한 회의</span>
            <div
              class="dataTable detail"
              style="padding-top: 0; padding-left: 0; padding-bottom: 0;"
            >
              <table
                style="border-top: 2px solid #333; margin-top: 10px;"
                cellpadding="0"
                cellspacing="0"
              >
                <caption>
                  이 표는 구성되어 있습니다.
                </caption>
                <colgroup>
                  <col style="width:40%" />
                  <col style="width:60%" />
                </colgroup>
                <tbody v-if="selectedBookmarkList">
                  <tr v-if="selectedBookmarkList.layoutCode">
                    <td>
                      <span class="date_title info-cs">레이아웃</span>
                    </td>
                    <td style="padding-top: 5px;">
                      <img
                        id="bookmarkImage"
                        :src="
                          selectedBookmarkList.layoutImage.replace(
                            '/layout/layout_',
                            '/fix/layout'
                          )
                        "
                      />
                    </td>
                  </tr>
                  <tr v-if="selectedBookmarkList.meetingLog">
                    <td>
                      <span class="date_title info-cs">AI 회의록</span>
                    </td>
                    <td class="name">
                      O
                    </td>
                  </tr>
                  <tr v-if="selectedBookmarkList.isRecord">
                    <td>
                      <span class="date_title info-cs">녹화</span>
                    </td>
                    <td class="name">
                      O
                    </td>
                  </tr>
                  <tr v-if="selectedBookmarkList.allPublicMeeting === true">
                    <td>
                      <span class="date_title info-cs">전체 공개회의</span>
                    </td>
                    <td class="name">
                      O
                    </td>
                  </tr>
                  <tr v-if="selectedBookmarkList.meetingPW !== null">
                    <td>
                      <span class="date_title info-cs">비밀번호</span>
                    </td>
                    <td class="name">
                      {{ selectedBookmarkList.meetingPW }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- //.list_on -->
        </div>
        <!-- // .popup_tel_wrap -->
      </div>
      <!-- //<div class="dataTable> -->
      <div class="btnArea" style="justify-content: center; margin-top:10px;">
        <button class="noIconButton" @click="closeDialog()">
          취소
        </button>

        <button class="btnPrimary" @click="submitBookmark()">
          불러오기
        </button>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import Util from "@/util";
import debounce from "lodash.debounce";
import moment from "moment";
export default {
  components: {},
  filters: {
    dayConversion: function(time) {
      return moment(time).format("YYYY.MM.DD");
    },
    timeConversion: function(time) {
      return moment(time).format("HH:mm");
    },
  },
  props: ["dialog", "closeDialog"],
  data() {
    return {
      isOsStlye: {
        maxWidth: "750px",
        marginLeft: 0,
      },
      loading: true,
      error: null,
      btnActive: "#9fa9ae",
      isActive: "none",
      meetingBookmarks: [],
      selectedBookmarkList: null,
      checkedMembers: [] /* 체크박스 유저 정보 */,
    };
  },
  computed: {
    calData() {
      let newObj = this.meetingBookmarks.map(function(element, index) {
        let attendees_str = "";

        if (element.attendees.length === 1) {
          if (element.attendees[0].name) {
            attendees_str = `${element.attendees[0].name}`;
          } else {
            attendees_str = `${element.attendees[0].email}`;
          }
        } else if (element.attendees.length > 1) {
          if (element.attendees[0].name) {
            attendees_str = `${element.attendees[0].name} 외 ${element.attendees
              .length - 1}명`;
          } else {
            attendees_str = `${element.attendees[0].email} 외 ${element
              .attendees.length - 1}명`;
          }
        }

        element["attendeesString"] = attendees_str;
        element["bindActive"] = false;
        return element;
      });

      return newObj;
    },
    attendeesString() {
      let attendees_str = "";
      if (this.selectedBookmarkList.attendees.length === 1) {
        if (this.selectedBookmarkList.attendees[0].name) {
          attendees_str = `${this.selectedBookmarkList.attendees[0].name}`;
        } else {
          attendees_str = `${this.selectedBookmarkList.attendees[0].email}`;
        }
      }
      return attendees_str;
    },
  },
  watch: {
    dialog: function(newVal) {
      if (newVal === true) {
        this.init();
        this.search();
      }
    },
  },
  mounted() {
    this.loading = false;
  },
  methods: {
    init() {
      this.isActive = "none";
      this.btnActive = "#9fa9ae";
      this.error = null;
      this.selectedBookmarkList = null;
    },
    close() {
      this.init();
      this.closeDialog(undefined);
    },

    search: debounce(async function(siteName) {
      let params = {
        owner: this.$store.state.user.empNum,
      };

      await this.$http
        .get("/api/v1/meetings/meeting_bookmark", { params: params })
        .then(response => {
          let data = response.data;
          this.meetingBookmarks = data;
          console.log(data);
        })
        .catch(error => {
          console.log(error);
        });
    }, 200),
    selectBookmark(bookmark) {
      console.log(bookmark);
      this.meetingBookmarks.forEach(obj => {
        obj.bindActive = false;
      });
      bookmark.bindActive = true;
      this.selectedBookmarkList = bookmark;
      if (bookmark.meetingPW === "" || bookmark.meetingPW === null) {
        this.selectedBookmarkList.meetingPW = null;
      }
    },
    submitBookmark() {
      if (this.selectedBookmarkList === null) {
        this.init();
        this.closeDialog();
      } else {
        this.$emit("selectedBookmarkMeeting", this.selectedBookmarkList);
        this.closeDialog();
        this.init();
      }
    },
    openDeleteBtn() {
      if (this.isActive === "none") {
        this.isActive = "";
        this.btnActive = "#0d99de";
      } else {
        this.isActive = "none";
        this.btnActive = "#9fa9ae";
      }
    },
    async deleteMeetingBookmark(id) {
      this.checkedMembers.push(id);
      let params = {
        bookmarkIds: this.checkedMembers,
      };
      await this.$http
        .delete("/api/v1/meetings/meeting_bookmark", { params: params })
        .then(response => {
          if (response.data === "ok") {
            Util.snackBarOpen("저장된 회의가 삭제되었습니다.", "success");
            this.search();
            if (
              this.selectedBookmarkList &&
              this.checkedMembers.includes(this.selectedBookmarkList._id)
            ) {
              this.selectedBookmarkList = null;
            }
            this.checkedMembers = [];
          } else {
            Util.snackBarOpen(
              this.$t("page.meeting-reserve.bookmark.delete-bookmark-fail-msg"),
              "error"
            );
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    async deleteBookmark() {
      if (!this.checkedMembers || this.checkedMembers.length === 0) {
        return alert("삭제 할 즐겨찾기를 하나 이상 선택 하세요");
      }

      let params = {
        bookmarkIds: this.checkedMembers,
      };

      await this.$http
        .delete("/api/v1/meetings/meeting_bookmark", { params: params })
        .then(response => {
          if (response.data === "ok") {
            Util.snackBarOpen(
              this.$t("page.meeting-reserve.bookmark.delete-bookmark-msg"),
              "success"
            );
            this.search();
            if (
              this.selectedBookmarkList &&
              this.checkedMembers.includes(this.selectedBookmarkList._id)
            ) {
              this.selectedBookmarkList = null;
            }
            this.checkedMembers = [];
          } else {
            Util.snackBarOpen(
              this.$t("page.meeting-reserve.bookmark.delete-bookmark-fail-msg"),
              "error"
            );
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
  },
};
</script>
<style scoped>
a {
  color: #464646;
  font-weight: 300;
}
.seltabcontent .seltab {
  width: 9%;
}
.p_ad {
  width: 42%;
  border: 1px solid #989898;
  border-radius: 5px;
  padding: 30px 15px 25px 15px;
  position: relative;
  font-weight: 500;
}

.seltab_r .scroll_tit li {
  float: left;
  height: 23px;
  padding-top: 7px;
  padding-bottom: 3px;
  text-align: center;
  border-top: 2px solid #fa4242;
  border-bottom: 1px solid #fa4242;
}

.checkbox {
  position: relative;
  font-size: 12px;
  float: none;
  padding: 0;
}
.checkbox input[type="checkbox"] {
  display: none;
}
.checkbox input[type="checkbox"] + label:before {
  position: unset;
  border: none;
}

.popContainer .checkbox input[type="checkbox"] + label {
  border: 1px solid #7f7f7f;
  display: inline-block;
  width: 12px;
  height: 12px;
  background: #fff;
  cursor: pointer;
  position: unset;
  padding: 0;
}
.popContainer .checkbox :after {
  display: block;
  clear: both;
  content: "";
}
.popContainer .checkbox input[type="checkbox"]:checked + label:before {
  position: unset;
  left: 0;
  top: 0;
  background: #fff;
  width: 0;
  height: 0;
  border: none;
}

.popContainer .checkbox input[type="checkbox"]:checked + label:after {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 10px;
  height: 10px;
  background: #fa4242;
}

/* 선택목록 스크롤 바 */
.mCustomScrollbar::-webkit-scrollbar {
  width: 6px;
}
.mCustomScrollbar::-webkit-scrollbar-track {
  background-color: transparent;
}
.mCustomScrollbar::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background-color: gray;
}
.mCustomScrollbar::-webkit-scrollbar-button {
  width: 0;
  height: 0;
}
.seltab .btn_com {
  display: inline-block;
  width: 60px;
  height: 30px;
  line-height: 30px;
  padding: 0;
  color: white;
}
.btn_com {
  color: white;
}
.btn_linedf {
  color: #fa4242;
}

/* 체크박스 */
.btn_check_box > .container-checkbox {
  display: block;
  position: relative;
  cursor: pointer;
  font-size: 17px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  float: left;
  margin-right: 10px;
  font-size: 17px;
  width: 100%;
}

.btn_check_box > .container-checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  width: 50px;
  height: 30px;
  z-index: 100;
  top: -16px;
  right: 0px;
}

.btn_check_box > .container-checkbox .checkmark {
  position: absolute;
  border: 1px solid #7f7f7f;
  display: inline-block;
  width: 15px;
  height: 15px;
  background: #fff;
  cursor: pointer;
  top: -5px;
  right: 18px;
}

/* On mouse-over, add a grey background color */
.btn_check_box > .container-checkbox:hover input ~ .checkmark {
}

/* When the checkbox is checked, add a blue background */
.btn_check_box > .container-checkbox input:checked ~ .checkmark {
  background-color: white;
}

/* Create the checkmark/indicator (hidden when not checked) */
.btn_check_box > .container-checkbox .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.btn_check_box > .container-checkbox input:checked ~ .checkmark:after {
  display: block;
  content: "";
  top: 1px;
  left: 1px;
  width: 11px;
  height: 11px;
  background: #fa4242;
}

/* Style the checkmark/indicator */
.btn_check_box > .container-checkbox .checkmark:after {
  left: 8px;
  top: 4px;
  width: 5px;
  height: 10px;
  border-width: 0 3px 3px 0;
}

.btn_check_box {
  padding-top: 4px;
}

.bookmark-delete-btn {
  float: right;
  border: none;
  border-radius: 5px;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: #fff;
  width: 80px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  cursor: pointer;
}
#bookmarkMeeting .dataTable table td {
  height: 40px;
  padding-top: 13px;
  padding-bottom: 13px;
  color: #333;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 22.5px */
  letter-spacing: -0.6px;
}

#bookmarkImage {
  float: left;
  width: 80px;
  margin-top: 4px;
  margin-bottom: 8px;
}

#bookmarkFixLayout {
  float: left;
  width: 100%;
  margin-top: 0;

  font-size: 12px;
}

.fix-seat-list {
  font-size: 12pt;
  margin: 0 !important;
}

.activeTarget {
  color: #604af3 !important;
}
.layout-close-btn {
  padding: 6px 15px;
  border: none;
  border-radius: 5px;
  background: #1757a1;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #fff;
  letter-spacing: -1px;
  margin-left: 0;
}

.delete-all-btn {
  width: 80px;
  height: 25px;
  float: right;
  font-size: 10pt;
  background: brown;
  color: white;
  border-radius: 5px;
  margin-top: 10px;
}

.member-area-tb {
  padding-top: 10px;
}

.member-area-tb thead {
  background: gray;
  color: white;
}

.member-area-tb th {
  padding-left: 5px;
  text-align: left;
  border: 1px solid black;
}

.selected-layout-wrap {
  float: left;
  width: 50%;
}
.list_info {
  min-height: 240px;
}
.member-top-area {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.button_area button {
  background: white;
  border: 1px solid #777777;
  color: #333333;
  border: 1px solid #777777;
  height: 40px;
}
.fix-seat-list-wrap {
  float: left;
  width: 50%;
}

.input_area {
  width: 335px !important;
  padding-top: 0px !important;
  padding-bottom: 0px;
}

.help-bg {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: black;
  opacity: 0.98;
  z-index: 999;
  overflow-y: auto;
  overflow-x: auto;
  text-align: center;
}
.help-img {
  width: 100%;
  max-width: 670px;
  display: inline-block;
  position: relative;
  top: 7%;
}

.close-img {
  position: fixed;
  top: 10%;
  right: 10%;
  cursor: pointer;
  z-index: 1001;
}

.btnArea {
  display: flex;
  justify-content: center;
}

.invite-btn {
  background-color: #604af3;
  color: white;
  width: 100px;
  height: 48px;
  border-radius: 8px;
  margin: 0 5px;
  font-size: 15px;
}
.close-btn {
  width: 100px;
  height: 48px;
  border-radius: 8px;
  background: #f2f2f2;
  color: #1f2e3d;
  margin: 0 5px;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/BookmarkMeetingDialog.vue